var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interface"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"btn"},[_c('div',{on:{"click":function($event){return _vm.go_back()}}},[_vm._v("返回首页")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordone"},[_c('p',[_vm._v("404 "),_c('span',[_vm._v("NOT FOUND")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordtwo"},[_c('p',[_vm._v("抱歉，未找到该页面")])])
}]

export { render, staticRenderFns }